import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class DailyLogssRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Get daily log
   */
  getDailyLog(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/show${query}`;
    return this.http.get(url);
  }

  /**
   * Create a new daily log
   * @param payload daily log params
   */
  createDailyLog(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}`;
    return this.http.post(url, payload);
  }

  /**
   * Submit daily log for a submitter
   * @param id daily log id
   * @param payload operation payload
   */
  submitDailyLogSubmitter(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/submit`;
    return this.http.patch(url, payload);
  }

  completeDay(contractId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/complete${query}`;
    return this.http.post(url, {}).toPromise()
  }

  reopenDay(contractId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/reopen${query}`;
    return this.http.post(url, {}).toPromise()
  }


  /**
   * Get list of daily logs
   */
  listDailyLogs(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/list`;
    return this.http.get(url, payload);
  }

  listAvailableDailyLogsForCopy(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/copy/availabledates`;
    return this.http.get(url, payload);
  }

  /**
   * Get daily log Show Details
   */
  listDailyLogShow(payload) {
    const query = this.helpers.queryOptions(payload);
    // GET {{domain}}/v2/daily_logs/show?calendarDate={{calendarDate}}&contractDefinitionId={{contractDefinitionId}}&retrieveSectionData=false
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/show${query}`;
    return this.http.get(url);
  }

  listDailyContracts(type, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/contracts/${type}${query}`;
    return this.http.get(url);
  }

  /**
   * List all child contracts by parent id
   * @param payload query options
   */
  listDailyContractsByParentId(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contractDefinitions}/children${query}`;
    return this.http.get(url);
  }

  /**
   * Copy a daily log from a given date
   * @param payload will contain the date and other params
   */
  copyDailyLog(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/copy`;
    return this.http.post(url, payload);
  }

  /**
   * Get headcounts from a daily log
   * @param id daily log id
   */
  getHeadcount(id) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/headcount`;
    return this.http.get(url);
  }

  /**
   * Get recorded headcounts from a daily log
   * @param id daily log id
   */
  getRecordedHeadCounts(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/headcount/recorded`;
    return this.http.get(url, payload);
  }

  /**
   * Update recorded headcount
   * @param id daily log id
   * @param payload store payload
   */
  updateHeadcount(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/headcount`;
    return this.http.put(url, payload);
  }

  /**
   * Get general questionnaire questions
   * @param id daily log id
   * @param payload endpoint options like pagination
   */
  getGeneralQuestionaire(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/general_questionnaire/answer`;
    return this.http.get(url, payload);
  }

  /**
   * Get safety questionnaire questions
   * @param id daily log id
   * @param payload endpoint options like pagination
   */
  getSafetyQuestionaire(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/safety_questionnaire/answer`;
    return this.http.get(url, payload);
  }

  /**
   * Save answers for general questionnaire/
   * @param id daily log id
   * @param payload content to be saved
   */
  storeAnswerGeneralQuestionaire(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/general_questionnaire/answer`;
    return this.http.put(url, payload);
  }

  /**
   * Save answers for safety questionnaire/
   * @param id daily log id
   * @param payload content to be saved
   */
  storeAnswerSafetyQuestionaire(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/safety_questionnaire/answer`;
    return this.http.put(url, payload);
  }

  /**
   * Get daily logs tasks for a submitter
   * @param id daily log id
   */
  getSubmitterTasks(id) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_tasks`;
    return this.http.get(url);
  }

  /**
   * Get daily logs tasks By TaskId
   * @param id daily log id
   */
  getSubmitterTask(dailyLogId, taskId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${dailyLogId}/daily_tasks/${taskId}`;
    return this.http.get(url);
  }

  /**
   * GET List Contracts Definitions
   * @param id daily log id
   */
  getListContractsDefinitions(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contractDefinitions}/list${query}`;
    //{{domain}}/v2/contract_definitions/list?submitToContractId={{submitToContractId}}&calendarDate=2019-06-18&page=1&limit=5&statusTypeId&state&search
    return this.http.get(url);
  }

  /**
   * Save task
   * @param id daily log id
   * @param payload content to be saved
   */
  storeSubmitterTask(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_tasks`;
    return this.http.post(url, payload);
  }

  /**
   * update task task
   * @param dailyId daily log id
   * @param taskId task id
   * @param payload content to be saved
   */
  updateSubmitterTask(dailyId, taskId, payload ) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${dailyId}/daily_tasks/${taskId}`;
    return this.http.patch(url, payload);
  }

  /**
   * Delete task 
   * @param id daily log id
   * @param taskId task id to be deleted
   */
  deleteSubmitterTask(id, taskId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_tasks/${taskId}`;
    return this.http.delete(url);
  }

  /**
   * Get daily log notes
   */
  getSubmitterNotes(id, options) {
    const query = this.helpers.queryOptions(options);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_notes${query}`;
    return this.http.get(url);
  }


  /**
   * Get daily log notes
   */
  getSubmitterNote(dailyLogId, noteId) {
    //const query = this.helpers.queryOptions(options);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${dailyLogId}/daily_notes/${noteId}`;
    return this.http.get(url);
  }

  /**
   * Save note
   * @param id daily log id
   * @param payload content to be saved
   */
  storeSubmitterNotes(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_notes`;
    return this.http.post(url, payload);
  }

  /**
   * update note
   * @param dailyId daily log id
   * @param noteID note id
   * @param payload content to be saved
   */
  updateubmitterNotes(dailyId, noteID, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${dailyId}/daily_notes/${noteID}`;
    return this.http.patch(url, payload);
  }


  /**
   * Delete task 
   * @param id daily log id
   * @param taskId task id to be deleted
   */
  deleteSubmitterNote(id, noteId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_Notes/${noteId}`;
    return this.http.delete(url);
  }

  /**
   * Get daily log photos
   */
  getSubmitterPhotos(id, options) {
    const query = this.helpers.queryOptions(options);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_photos${query}`;
    return this.http.get(url);
  }

  /**
   * Get daily log section to show photos
   * @param id daily log id
   * @param section daily log photo section
   * @param options queyr params
   */
  getSubmitterShowPhotos(id, section, options) {
    const query = this.helpers.queryOptions(options);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_photos/${section}${query}`;
    return this.http.get(url);
  }

    /**
   * Save album
   * @param id daily log id
   * @param payload content to be saved
   */
  storeSubmitterPhotos(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_photos`;
    return this.http.post(url, payload);
  }

  /**
   * update photo
   * @param dailyId daily log id
   * @param albumId album id
   * @param payload content to be saved
   */
  updateSubmitterPhotos(dailyId, albumId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${dailyId}/daily_photos/${albumId}`;
    return this.http.post(url, payload);
  }

  /**
   * remove album
   * @param id daily log id
   * @param section daily log photo section
   * @param payload content to be saved
   */
  removeSubmitterPhotos(id, section, payload?) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/${id}/daily_photos/${section}`;
    return this.http.delete(url);
  }

  /*
  * GET List Contract Daily Status Headcount
  */
  getListContractDailyStatusHeadcount(contractId, calendarDate, payload) {
    // const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/headcount`;
    return this.http.get(url).toPromise();
  }

  /**
  * GET List Contract Daily Status Tasks
  */
  getListContractDailyStatusTasks(contractId, calendarDate, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/tasks`;
    return this.http.get(url).toPromise();
  }


  /**
  * GET List Contract Daily Status Notes
  */
  getListContractDailyStatusNotes(contractId, calendarDate, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/notes`;
    return this.http.get(url).toPromise();
  }

  /**
  * GET List Contract Daily Status Photos
  */
  getListContractDailyStatusPhotos(contractId, calendarDate, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/photos`;
    return this.http.get(url).toPromise();
  }


  /**
  * GET List Contract Daily Status Safety 
  */
  getListContractDailyStatusSafety(contractId, calendarDate, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/safety_questionnaire`;
    return this.http.get(url).toPromise();
  }


  /**
  * GET List Contract Daily Status General Questionnaire 
  */
  getListContractDailyStatusQuestionnaire(contractId, calendarDate, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/${calendarDate}/general_questionnaire`;
    return this.http.get(url).toPromise();
  }

  /**
   * Get list of trades
   * @param contractId 
   * @param payload 
   */
  getTrades(contractId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/trades${query}`;
    return this.http.get(url);
  }


  getDonwloadDailyLog(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/download`;
    return this.http.get(url, payload).toPromise();
  }

}
